import React, { useState } from 'react';
import { shape, string, bool, func } from 'prop-types';
import { useIntl } from 'react-intl';
import { getI18n } from '../../../../utils/intl';
import {
  Button,
  withStyles,
} from '@material-ui/core';

import styles from './styles';
import { USER_STATUS_DISABLED, USER_STATUS_ENABLED, USER_STATUS_LOCKED, USER_STATUS_REGISTRATION_INIT, USER_STATUS_REGISTRATION_PENDING_APPROVAL } from '../../../../constants';
import { DetailsHeader as Header } from '../../../../components';
import { AlertDialog, FormSelect, StatusIndicator } from '../../../../components';
export const getStatusColor = (classes, status) => {
  let statusLabel = '';
  let statusColorClass = '';
  switch (status) {
    case USER_STATUS_ENABLED:
      statusLabel = 'enabled';
      statusColorClass = classes.available;
      break;
    case USER_STATUS_DISABLED:
      statusLabel = 'disabled';
      statusColorClass = classes.unavailable;
      break;
    case USER_STATUS_REGISTRATION_INIT:
      statusLabel = 'registration.init';
      statusColorClass = classes.pending;
      break;
    case USER_STATUS_REGISTRATION_PENDING_APPROVAL:
      statusLabel = 'registration.pending.approval';
      statusColorClass = classes.pending;
      break;
    case USER_STATUS_LOCKED:
      statusLabel = 'locked';
      statusColorClass = classes.unavailable;
      break;
    default:
      statusLabel = 'nostatus';
      statusColorClass = classes.noStatus;
  }
  statusLabel = `label.user.status.${statusLabel}`;
  return {
    statusLabel, statusColorClass,
  }
};
export const DetailsHeader = (props) => {
  const {
    classes,
    headerId,
    title,
    name,
    status,
    showDelete = false,
    deleteFn,
    changeStatus,
    resendActivationEmail,
    isDefaultAuthScheme,
    deleteButtonLabel,
  } = props;

  const { statusLabel, statusColorClass } = getStatusColor(classes, status);
  const [ resendEmailClicked, setResendEmailClicked] = useState(false);
  const intl = getI18n(useIntl());
  const onClickStatusButton = () => { changeStatus(status) };
  const handleStatusChange = (evt) => { evt.target.value === 'enable' ?
                        changeStatus(USER_STATUS_DISABLED) :
                        changeStatus(USER_STATUS_ENABLED) };
  const showStatusButton= (status === USER_STATUS_DISABLED || status === USER_STATUS_ENABLED);
  const showStatusDropdown = (status === USER_STATUS_LOCKED);
  const statusOptions = [
    {
      uuid: 'enable',
      name: intl.getI18nMessage('label.user.status.enable'),
    },
    {
      uuid: 'disable',
      name: intl.getI18nMessage('label.user.status.disable'),
    },
  ];
  const Status = () =>
    <div className={classes.statusContainer}>
      <StatusIndicator
        label={intl.getI18nMessage(statusLabel)}
        colorClass={statusColorClass}
      />
      {showStatusButton && <Button
        id="status-button"
        color="primary"
        variant="outlined"
        data-apim-test="status-button"
        className={classes.cancelButton}
        onClick={onClickStatusButton}
      >
        {intl.getI18nMessage(`label.application.details.overview.${status === USER_STATUS_ENABLED ? 'disable': 'enable'}.button.text`)}
      </Button>}
      {showStatusDropdown && <FormSelect
          fieldContainerClass={classes.noMargin}
          selectFieldClass={classes.noMargin}
          id="user-status-drop-down"
          data={statusOptions}
          value={''}
          handleChange={handleStatusChange}
          defaultText={intl.getI18nMessage('label.user.status.set.state')}
        />}
    </div>;

  return (
    <div>
      <AlertDialog
        isOpen={resendEmailClicked}
        title={intl.getI18nMessage('label.user.details.resend.email.dialog.title')}
        description={intl.getI18nMessage('label.user.details.resend.email.dialog.description')}
        submitText={intl.getI18nMessage('label.user.details.resend.email.dialog.submit')}
        cancelText={intl.getI18nMessage('label.user.details.resend.email.dialog.cancel')}
        onClose={() => setResendEmailClicked(false)}
        onSubmit={() => {
                setResendEmailClicked(false);
                resendActivationEmail();}
              }
        onCancel={() => setResendEmailClicked(false)}
        dialogId="resend-activation-email-confirm-dailog"
      />
      <Header
        headerId={headerId}
        title={title}
        name={name}
        status={status}
        showDelete={showDelete}
        deleteFn={deleteFn}
        statusComponent={<Status />}
        showOptionalButton={isDefaultAuthScheme && (status === USER_STATUS_REGISTRATION_INIT)}
        optionalButtonLabel={intl.getI18nMessage('label.user.details.header.resend.activation.mail')}
        optionalButtonClass={classes.resendButton}
        optionalButtonOnClick={() => setResendEmailClicked(true)}
        deleteButtonLabel={deleteButtonLabel}
      />
    </div>
  );
};

DetailsHeader.propTypes = {
  classes: shape({}),
  headerId: string,
  title: string,
  name: string,
  status: string,
  deleteFn: func,
  showDelete: bool,
  changeStatus: func,
  resendActivationEmail: func,
  isDefaultAuthScheme: bool,
  deleteButtonLabel: string,
};
DetailsHeader.displayName = 'DetailsHeader';

export default withStyles(styles)(DetailsHeader);
